var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideAdvrtisement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.8892 3.70996L19.5352 5.06006C19.9791 5.51006 20.3313 6.02999 20.5716 6.60999C20.8119 7.18999 20.9356 7.80994 20.9356 8.43994C20.9356 9.05994 20.8119 9.69001 20.5716 10.26C20.3313 10.84 19.9791 11.3701 19.5352 11.8101L20.8892 13.17C22.1422 11.91 22.8461 10.2099 22.8461 8.43994C22.8461 6.66994 22.1422 4.96997 20.8892 3.71997V3.70996Z",
    fill: "#11074C",
    style: {
      fill: "#88b2f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5898 1.11035L22.2598 2.44031C23.847 4.03031 24.7383 6.19031 24.7383 8.44031C24.7383 10.6803 23.847 12.8404 22.2598 14.4304L23.5898 15.7604C24.5519 14.8004 25.3151 13.6604 25.8358 12.4004C26.3566 11.1404 26.6246 9.80031 26.6246 8.44031C26.6246 7.08031 26.3566 5.73034 25.8358 4.47034C25.3151 3.22034 24.5519 2.07035 23.5898 1.11035Z",
    fill: "#11074C",
    style: {
      fill: "#88b2f0"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 6.09998V0H15.375L9.75 4.68994H2.25L0.375 5.63V12.1899L2.25 13.13L6.938 20.63H9.75L7.992 13.13H9.75L15.375 16.88H17.25V10.78C17.7981 10.69 18.2945 10.4 18.6416 9.96997C18.9886 9.53997 19.161 8.98994 19.125 8.43994C19.1613 7.88994 18.989 7.34003 18.6419 6.91003C18.2949 6.47003 17.7983 6.18998 17.25 6.09998Z",
    fill: "#88B2F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideAdvrtisement);
export default __webpack_public_path__ + "static/media/side-advrtisement.64fe6fc2d1af884aa1faeb2581bd454a.svg";
export { ForwardRef as ReactComponent };